<template>
  <div class="wd-py-2 wd-px-4 xs:wd-px-0">
    <div class="wd-w-full wd-h-22 wd-flex wd-justify-around wd-flex-wrap">
      <OrderStatusBoardItem v-for="(s, index) in result" :key="s.text" v-bind="s" :sno="index + 1" />
    </div>
    <div v-if="showPureBookingHint" class="wd-w-full wd-text-xs wd-text-gray80">{{ $t('order_status_redeemed_hint') }}</div>
  </div>
</template>

<script setup lang="ts">
import OrderStatusBoardItem from '@/components/OrderStatusBoardItem.vue'
import { OrderDetailDisplayStatus, OrderDetailDisplayStatusMap } from '@/view-models/order'

defineOptions({
  name: 'OrderStatusBoard',
})

interface Props {
  displayStatus: OrderDetailDisplayStatus
}

const props = withDefaults(defineProps<Props>(), {
  displayStatus: OrderDetailDisplayStatus.CANCEL,
})

const { $i18n } = useNuxtApp()

const result = computed(
  () =>
    OrderDetailDisplayStatusMap[props.displayStatus]?.map(r => ({
      ...r,
      text: $i18n.t(r.text),
    })) || []
)

const showPureBookingHint = computed(() => {
  return props.displayStatus === OrderDetailDisplayStatus.BOOKED_PURE_REDEEMED_UNCOMMENTED
})
</script>
